import classNames from 'classnames';
import { ErrorMessage, Field, useFormikContext } from 'formik';
import React, { memo } from 'react';
import FormField from '../FormField/FormField';
import { FormFieldBlokProps } from '../FormFieldBlokProps.interface';
import { FormFieldSelectOptionBlokProps } from '../FormFieldSelectOptionBlokProps.interface';

export interface FormFieldSingleOptionSelectDropdownBlokProps
  extends FormFieldBlokProps {
  options: FormFieldSelectOptionBlokProps[];
  preselected_option: FormFieldSelectOptionBlokProps[];
  controls_form_state?: boolean;
  updateState?: React.Dispatch<any>;
}

interface FormFieldSingleOptionSelectDropdownProps {
  blok: FormFieldSingleOptionSelectDropdownBlokProps;
}

const FormFieldSingleOptionSelectDropdown: React.FC<
  FormFieldSingleOptionSelectDropdownProps
> = ({ blok }) => {
  const {
    label,
    description = undefined,
    is_required,
    error_message = undefined,
    tool_tip = [],
    key,
    options,
    preselected_option,
    controls_form_state = false,
    updateState = undefined,
  } = blok;

  const { errors, touched } = useFormikContext<any>();

  return (
    <FormField
      label={label}
      description={description}
      errorMessage={error_message}
      toolTip={tool_tip}
      key={key}
    >
      <Field
        as="select"
        name={key}
        id={key}
        className={classNames(
          'w-full h-14 bg-system/white border border-border/default rounded-default text-text/body font-dm-sans focus:!ring-0 focus:!outline-none',
          {
            'border-border/error': errors[key] && touched[key],
            'border-border/success': !errors[key] && touched[key],
          }
        )}
      >
        <option value="" disabled={true}>
          {'Select an option'}
        </option>
        {options.map((option: FormFieldSelectOptionBlokProps) => (
          <option key={option.value} value={option.value}>
            {option.description}
          </option>
        ))}
      </Field>
      <ErrorMessage
        name={key}
        render={(msg) => <div className="text-text/body-primary">{msg}</div>}
      />
    </FormField>
  );
};

export default memo(FormFieldSingleOptionSelectDropdown);
